import { ObjectItem } from "@/lib/stores/objectsStore";
import { GlossaryBlueprint } from "@/types-games";
import IconProvider from "../ui/IconProvider";
import { extractBlueprintVersion } from "@/lib/utils/versionUtils";
import { versionsMatch } from "@/lib/utils/versionUtils";
interface OutOfSyncObjectsListProps {
    outOfSyncObjects: ObjectItem[];
    blueprint: GlossaryBlueprint;
}

export default function OutOfSyncObjectsList({ outOfSyncObjects, blueprint }: OutOfSyncObjectsListProps) {
    return (
        <div className="border-t border-warning/30 bg-background/50 p-4">
            <h4 className="text-sm font-semibold mb-3">Outdated Objects:</h4>
            <div className="space-y-1 max-h-64 overflow-y-auto">
                {outOfSyncObjects.map((obj: ObjectItem) => {
                    return (
                        <div
                            key={obj.id}
                            className="flex items-center justify-between p-2 rounded bg-card hover:bg-accent/50 transition-colors"
                        >
                            <div className="flex-1 min-w-0">
                                <div className="font-medium text-sm truncate">{obj.name}</div>
                                <div className="text-xs text-muted-foreground">
                                    Version {String(obj.blueprint_version)} → {String(extractBlueprintVersion(blueprint))}
                                </div>
                            </div>

                        </div>
                    );
                })}
            </div>
        </div>
    );
}